// Dot-notation attribute keys ('headers1.KarmakAccountNumber') used by Shared
// Settings, so a single header entry can be mapped instead of the whole object.

export function parseAttributeKey(name) {
  if (!name) return { baseName: '', subKey: null };
  const dotIdx = name.indexOf('.');
  if (dotIdx === -1) return { baseName: name, subKey: null };
  return {
    baseName: name.substring(0, dotIdx),
    subKey: name.substring(dotIdx + 1),
  };
}

export function isHeaderKey(name) {
  return typeof name === 'string' && name.includes('.');
}

// Returns the value for a specific key from a headers tuple array.
// headersArray shape: [['KarmakAccountNumber', '27472', false], ...]
export function getHeaderValue(headersArray, key) {
  const tuple = (headersArray || []).find((t) => t[0] === key);
  return tuple ? tuple[1] : undefined;
}

// Returns a new array with the given key set to value.
// Updates the existing tuple if the key exists, otherwise appends a new one.
export function setHeaderValue(headersArray, key, value) {
  const arr = Array.isArray(headersArray) ? headersArray : [];
  const idx = arr.findIndex((t) => t[0] === key);
  if (idx === -1) return [...arr, [key, value, false]];
  return arr.map((t, i) => (i === idx ? [t[0], value, t[2]] : t));
}
